import { useTranslation } from "react-i18next";

const NewInputGenericRegister = ({ handleChange, values, errors, placeholderVal, field, max_length, moduleText, occupation = 6, css_class, isRequired = true, digitsOnly = false, maxDigits = 15 }) => {
  const { t } = useTranslation();

  return (
    <div className={`col-md-${occupation}`}>
      <label htmlFor={field} className="form-label">
      {t(`${moduleText}.short.${field}`)}
      </label>
      <div className="control">
        <input
          autoComplete="off"

          className={`form-control form-control-lg ${errors[field] && "is-invalid"}`}
          type="text"
          name={field}
          id={field}
          inputMode={digitsOnly ? "numeric" : undefined}
          onChange={(event) => {
            if (digitsOnly) {
              event.target.value = String(event.target.value || "").replace(/\D/g, "").slice(0, maxDigits);
            }
            handleChange(event, field);
          }}
          value={values[field] || ""}
          required={isRequired}
          maxLength={digitsOnly ? maxDigits : max_length}
          placeholder={placeholderVal ? t(`${moduleText}.short.${field}`) : null}
        />
        {errors[field] && <pre> <p className="help text-danger">{errors[field]}</p> </pre>}
      </div>
    </div>
  )
}

export default NewInputGenericRegister

